'use strict';

export default function enquiryValues () {
    let $objectListInput = $('#offers_ids');

    return {
        update: () => $objectListInput.val(
            $.makeArray($('.js-enquiry-object:not(.slick-cloned)')
                .map((idx, el) => $(el).attr('data-id')
            )).join(',')
        )
    };
}
